import { LookupOption } from '../models/lookup.models';

/**
 * Display order for ASSIGNED_RESOURCE_STATUS options, shared by the edit dialog's status
 * select and the assignments card's row menu so the two list the same statuses in the
 * same order. The lookup's own sortOrder is not used: it orders the admin lookup screen,
 * while these two surfaces want the live states first. Codes outside the table sort last,
 * in the order the lookup gave them.
 */
export const ASSIGNMENT_STATUS_PRIORITY: Readonly<Record<string, number>> = {
  ACTIVE: 1,
  PENDING: 2,
  INACTIVE: 3,
  CLOSED: 4,
};

/** A copy of `options` in ASSIGNMENT_STATUS_PRIORITY order. The input is left as it was. */
export function sortAssignmentStatusOptions(
  options: readonly LookupOption[],
): LookupOption[] {
  return [...options].sort((a, b) => priorityOf(a) - priorityOf(b));
}

function priorityOf(option: LookupOption): number {
  return ASSIGNMENT_STATUS_PRIORITY[option.value.toUpperCase()] ?? 99;
}
